export const stages = ["PAID", "DELIVERED"];

export const stageNames = {
  PAID: "Recibidos",
  DELIVERED: "Entregados",
};

export const stagePlaceholder = {
  PAID: "Aquí verás nuevos pedidos de tus clientes.",
  DELIVERED: "Una vez entregado el pedido, arrástralo a esta columna.",
};

export const stageChoices = stages.map((type) => ({
  id: type,
  name: stageNames[type],
}));
